const DIRECTORY_NAME_MAX_LENGTH = 70 // Limit to avoid a long path when unzipping a bible

export {
  DIRECTORY_NAME_MAX_LENGTH,
}
